module.exports = __webpack_public_path__ + "img/wifi-1.4615fc91.svg";